import type { QueryClient } from '@tanstack/react-query';
import { redirect } from '@tanstack/react-router';
import type { VisualizationType } from '@tempo-io/roadmap-dto';
import {
  type PORTFOLIO_SAVED_VIEW_BASE,
  VISUALIZATIONS_SAVED_VIEW_BASE,
} from '@/features/views/hooks/useViewSurfacePaths';
import { getVisualizationsQueryOptions } from '@/features/views/queries/useViewVisualizations';
import { getLastVisitedVisualization } from './lastVisitedVisualizationView';
import { visualizationTypeToUrlSegment } from './visualizationTypeToUrlSegment';

export async function redirectToLoopVisualizationOfType({
  type,
  org,
  loopId,
  viewId,
  queryClient,
  savedViewBase = VISUALIZATIONS_SAVED_VIEW_BASE,
}: {
  type?: VisualizationType;
  org: string;
  loopId: number;
  viewId: number;
  queryClient: QueryClient;
  savedViewBase?: typeof PORTFOLIO_SAVED_VIEW_BASE | typeof VISUALIZATIONS_SAVED_VIEW_BASE;
}): Promise<void> {
  const visualizations = await queryClient.ensureQueryData(
    getVisualizationsQueryOptions({ orgId: '', loopId, viewId }),
  );

  const preferredType = type ?? getLastVisitedVisualization(viewId);
  const firstVisualization = preferredType
    ? (visualizations.find((v) => v.type === preferredType) ?? visualizations[0])
    : visualizations[0];

  if (firstVisualization) {
    throw redirect({
      to: `${savedViewBase}/${visualizationTypeToUrlSegment(firstVisualization.type)}`,
      params: { org, loopId, viewId },
      replace: true,
    });
  }
}
